import { AxiosResponse } from 'axios'
import { API } from '../config'
import { ChangePasswordDto, UserDto } from 'src/dto/user.dto'
import { UserParams } from 'src/domain/User/UserDomain'
import { LoginResponse } from 'src/contexts/auth/types'

const BASE_URL = '/entity/Usuario'

export class UserService {
  public async getUserListFromFarm(farmId: string): Promise<AxiosResponse<UserDto[]>> {
    return await API.get<UserDto[]>(`${BASE_URL}/${farmId}`)
  }

  public async changePassword(changePasswordDto: ChangePasswordDto): Promise<AxiosResponse<void>> {
    return await API.post(`/secure/mudarSenha`, changePasswordDto)
  }

  public async checkEmail(email: string): Promise<
    AxiosResponse<{
      errorMessage?: string
    }>
  > {
    return await API.get(`/checar?username=${encodeURIComponent(email)}`, {
      skipAuth: true
    })
  }

  public async changeProfile(farmId: string, changeProfileDto: UserParams): Promise<AxiosResponse<UserDto>> {
    return await API.put(`${BASE_URL}/${farmId}`, changeProfileDto)
  }

  public async registerUser(payload: any): Promise<AxiosResponse<LoginResponse>> {
    return await API.post(
      `/cadastrar`,
      { ...payload },
      {
        skipAuth: true
      }
    )
  }

  public async resetPassword(username: string): Promise<AxiosResponse<void>> {
    return await API.post(
      `/resetarSenha`,
      { username },
      {
        skipAuth: true
      }
    )
  }

  public async sendConfirmationCode(username: string, tipo: 'TELEFONE' | 'EMAIL'): Promise<AxiosResponse<void>> {
    return await API.post(
      `/enviarCodigoConfirmacao`,
      { username, tipo },
      {
        skipAuth: true
      }
    )
  }

  public async validateConfirmationCode(
    username: string,
    codigo: string,
    tipo: 'TELEFONE' | 'EMAIL'
  ): Promise<AxiosResponse<void>> {
    return await API.post(
      `/validarCodigoConfirmacao`,
      { username, codigo, tipo },
      {
        skipAuth: true
      }
    )
  }
}
